import { Link } from 'react-router-dom';

interface Crumb {
  label: string;
  path?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="max-w-7xl mx-auto px-4 md:px-6 py-4">
      <ol className="flex items-center flex-wrap gap-1 text-sm">
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-1">
            {index > 0 && (
              <span className="text-foreground-400 w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-s-line"></i>
              </span>
            )}
            {item.path ? (
              <Link
                to={item.path}
                className={`whitespace-nowrap transition-colors duration-200 ${
                  index === items.length - 1
                    ? 'text-foreground-900 font-medium'
                    : 'text-foreground-500 hover:text-primary-500'
                }`}
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-900 font-medium whitespace-nowrap">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}